var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.5C0 2.01472 2.01472 0 4.5 0H31.5C33.9853 0 36 2.01472 36 4.5V31.5C36 33.9853 33.9853 36 31.5 36H4.5C2.01472 36 0 33.9853 0 31.5V4.5Z",
    fill: "#E81717"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3864_187152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3864_187152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.25 23.6347C10.0375 23.6347 9.85942 23.5628 9.71575 23.419C9.57192 23.2753 9.5 23.0971 9.5 22.8845C9.5 22.672 9.57192 22.4939 9.71575 22.3502C9.85942 22.2067 10.0375 22.135 10.25 22.135H25.75C25.9625 22.135 26.1406 22.2068 26.2843 22.3505C26.4281 22.4943 26.5 22.6726 26.5 22.8852C26.5 23.0977 26.4281 23.2758 26.2843 23.4195C26.1406 23.563 25.9625 23.6347 25.75 23.6347H10.25ZM10.25 18.7502C10.0375 18.7502 9.85942 18.6783 9.71575 18.5345C9.57192 18.3906 9.5 18.2125 9.5 18C9.5 17.7873 9.57192 17.6092 9.71575 17.4657C9.85942 17.3221 10.0375 17.2502 10.25 17.2502H25.75C25.9625 17.2502 26.1406 17.3221 26.2843 17.466C26.4281 17.6098 26.5 17.788 26.5 18.0005C26.5 18.2131 26.4281 18.3912 26.2843 18.5347C26.1406 18.6784 25.9625 18.7502 25.75 18.7502H10.25ZM10.25 13.8655C10.0375 13.8655 9.85942 13.7936 9.71575 13.65C9.57192 13.5061 9.5 13.3279 9.5 13.1152C9.5 12.9027 9.57192 12.7246 9.71575 12.581C9.85942 12.4375 10.0375 12.3657 10.25 12.3657H25.75C25.9625 12.3657 26.1406 12.4376 26.2843 12.5815C26.4281 12.7251 26.5 12.9033 26.5 13.116C26.5 13.3285 26.4281 13.5066 26.2843 13.6502C26.1406 13.7937 25.9625 13.8655 25.75 13.8655H10.25Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMenu);
export default __webpack_public_path__ + "static/media/nav-menu.a69c04d4438cb344390ec44444235d53.svg";
export { ForwardRef as ReactComponent };